module.exports = __webpack_public_path__ + "img/corneal-staining-4.d6882276.jpg";